<template>
  <section class="register-content">
    <div class="main">
      <div class="loginlogo"><img src="../img/ico.png" width="80px"/></div>
      <div class="first">
        <div class="register_form" @input="clearWarning">
          <div class="username">
            <input type="text" value="" v-model="username" @keypress.enter="submit" placeholder="Username" autocomplete="off"/>
          </div>
          <div class="password">
            <input type="password" value="" v-model="password" @keypress.enter="submit" placeholder="Password" autocomplete="off"/>
          </div>
          <div class="password_again">
            <input type="password" value="" v-model="password_again" @keypress.enter="submit"  placeholder="Confirm Password" autocomplete="off"/>
          </div>
          <div class="Email">
            <input type="text" value="" v-model="email" @keypress.enter="submit" placeholder="Email" autocomplete="off"/>
          </div>
          <div class="buttons">
            <div class="error">{{msg}}</div>
            <button type="button" class="btn btn-outline-primary" @click="submit">Register</button>
          </div>

        </div>
        <div class="register-tips">Please register individually first, then you can create or join a team after you log in.</div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { hash } from '@/utils'
  import { register } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        msg: '',
        username: '',
        password: '',
        password_again: '',
        email: ''
      }
    },
    computed: {
      ...mapState(['v_locale']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'registerUser_', 'username_', 'password_',
        'retypePwd_', 'email_', 'submit_', 'reset_',
        'clickToLogin_', 'fillAll_', 'invalidUsername_',
        'notMatch_', 'invalidEmail_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      clearWarning () {
        this.msg = ''
      },
      submit () {
        if (!(this.username && this.password && this.password_again && this.email)) {
          this.msg = this.fillAll_
          return
        }
        if (!this.username.match(/[_a-zA-Z][-_a-zA-Z0-9.]{0,63}$/)) {
          this.msg = this.invalidUsername_
          return
        }
        if (this.password !== this.password_again) {
          this.msg = this.notMatch_
          return
        }
        if (!this.email.match(/^[^@]+@[^@]+\.[^@]+$/)) {
          this.msg = this.invalidEmail_
          return
        }

        const pass = hash(this.username, this.password)
        register(this.username, pass, this.email)
          .then(() => {
            this.$router.push('/profile')
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      reset () {
        this.username = ''
        this.password = ''
        this.password_again = ''
        this.email = ''
      }
    },
    created () {
      if (this.gameOver) return this.$router.replace('/rank')
    }
  }
</script>

<style lang="less" scoped>
.register-content {
  .main {
    .loginlogo{
      text-align: center;
      margin-top: 100px;
      >img{
            width: 150px;
      }
    }
    .first {
      .register_form{
        width: auto;
        div {
          width:500px;
          margin-top: 20px;
          input {
            color: #fff;
            font-family: 'Courier';
            height: 60px;
            width: 498px;
            padding-left: 50px;
            border: none;
            background: none;
            border-bottom: 1px solid #fff;

          }

          &.buttons {
            text-align: center;
            .btn{
              margin-left: 0px;
              width: 150px;
              color: #00c8e3;
              font-size: 18px;
              background: transparent;
            }

          }
        }
      }
      .register-tips{
        width:450px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        margin: auto;
        margin-top: 20px;
      }
      .username::before{
        content: '';
        background: url('../img/username.png') no-repeat bottom left /28px;
        position: absolute;
        margin-top: 15px;
        margin-left: 5px;
        z-index: 2;
        width: 32px;
        height: 40px;
      }
      .password::before{
        content: '';
        background: url('../img/password.png') no-repeat bottom left /28px;
        position: absolute;
        margin-top: 15px;
        margin-left: 5px;
        z-index: 2;
        width: 32px;
        height: 40px;
      }
      .password_again::before{
        content: '';
        background: url('../img/confirmPassword.png') no-repeat bottom left /28px;
        position: absolute;
        margin-top: 15px;
        margin-left: 5px;
        z-index: 2;
        width: 32px;
        height: 40px;
      }
      .Email::before{
        content: '';
        background: url('../img/email.png') no-repeat bottom left /32px;
        position: absolute;
        margin-top: 15px;
        margin-left: 5px;
        z-index: 2;
        width: 32px;
        height: 40px;
      }
    }
  }
}
::-webkit-input-placeholder { /* WebKit browsers */
  color:    #b7b7b7;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color:    #b7b7b7;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color:    #b7b7b7;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  color:    #b7b7b7;
}
input:-webkit-autofill {
  -webkit-animation: back 1s infinite;
}

@keyframes back{
  0%{background-color:transparent;color:#fff;}
  100%{background-color:transparent;color:#fff;}
}


</style>




// WEBPACK FOOTER //
// src/themes/dragon/components/register.vue